'use strict';

exports.__esModule = true;
exports.default = AccessDenied;
function AccessDenied(message) {
  this.name = 'AccessDenied';
  this.message = message;
}

AccessDenied.prototype = Error.prototype;


//////////////////
// WEBPACK FOOTER
// ./~/kindergarten/lib/errors/AccessDenied.js
// module id = S+d0
// module chunks = 0